module.exports = __webpack_public_path__ + "static/HHDxTKB_GIF_W-be00f06f2d1b4143075f9b6028c6e0c0.gif";